export default [
  {
    path: "/shop",
    name: "shopMainpage",
    component: () => import(/* webpackChunkName: "shop" */ "@/views/shop/shopRoute.vue"),
    children: [
      {
        path: "",
        name: "shopMainPage",
        component: () => import(/* webpackChunkName: "shop" */ "@/views/shop/shopMainpage.vue"),
        meta: {
          hideBottomNavigation: true,
        },
      },
      {
        path: "checkout",
        name: "shopCheckout",
        component: () => import(/* webpackChunkName: "shop" */ "@/views/shop/shopCheckout.vue"),
        meta: {
          hideBottomNavigation: true,
        },
      },
      {
        path: "payment/failed",
        name: "shopPaymentFailed",
        component: () => import(/* webpackChunkName: "shop" */ "@/views/shop/shopCheckPaymentFailed.vue"),
        meta: {
          hideBottomNavigation: true,
        },
      },
      {
        path: "check/payment",
        name: "shopCheckPayment",
        component: () => import(/* webpackChunkName: "shop" */ "@/views/shop/shopCheckPayment.vue"),
        meta: {
          hideBottomNavigation: true,
        },
      },
      {
        path: "purchase/infos/:id",
        name: "shopPurchaseInfos",
        component: () => import(/* webpackChunkName: "shop" */ "@/views/shop/shopPurchaseInfos.vue"),
        meta: {
          hideBottomNavigation: true,
        },
      },
      {
        path: ":id",
        name: "shopMainPageProduct",
        component: () => import(/* webpackChunkName: "shop" */ "@/views/shop/shopMainpage.vue"),
        meta: {
          hideBottomNavigation: true,
        },
      },
    ],
    meta: {
      hideBottomNavigation: true,
    },
  },
]
